import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { AppInitializationService } from 'src/app/core/services/app-initializer.service';
import { BaseService } from 'src/app/core/services/base.service';
import { PublicProfileService } from 'src/app/core/services/public-profile.service';
import { PublicProfile } from 'src/app/shared/models/people/public-profile.model';

@Injectable({ providedIn: 'root' })
export class PublicProfileResolver implements Resolve<any> {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private publicProfileService: PublicProfileService,
    private baseService: BaseService,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private appInitializationService: AppInitializationService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<PublicProfile | null> {
    return this.appInitializationService.isInitialized().pipe(
        filter(initialized => initialized),  // Esperar hasta que sea `true`
        take(1),  // Tomar solo el primer valor `true`
        switchMap(() => {  
          if(isPlatformBrowser(this.platformId)){
            
            const nickname = route.params.nickname;
            const language = this.locale.language;
            const accountName = this.baseService.getCliniwebDirectoryCompanyName();
            return this.publicProfileService.getPublicProfile(nickname, language, accountName).pipe(
                catchError(error => {
                  console.error('Error fetching public profile', error);
                  return of(null); // or handle the error as needed
                })
              );
          }
          else{
            return of(null);
          }
        })
      );
  }
}